export default __webpack_public_path__ + "static/media/TS_light_theme.d166eedc.png";